import { z } from 'zod';

import { DomainSessionId, DomainUserId } from '../primitive';

export const DomainIds = z.object({
  sessionId: DomainSessionId,
  userId: DomainUserId,
});

// eslint-disable-next-line no-redeclare
export type DomainIds = z.infer<typeof DomainIds>;
